import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import { AiFillQuestionCircle } from 'react-icons/ai';
import { SCREEN_SIZES } from 'style';
import { Container, TextTooltipContainer, Info, List, UnderlineText } from './styled';

const TextTooltip = ({ children, setIsModalOpen, text, className }) => {
  return (
    <TextTooltipContainer
      onClick={(e) => {
        e.stopPropagation();
        setIsModalOpen(true);
      }}
      className={className}
    >
      <UnderlineText>{text}</UnderlineText>
      {children}
    </TextTooltipContainer>
  );
};

TextTooltip.propTypes = {
  children: PropTypes.node,
  setIsModalOpen: PropTypes.func,
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};

const IconTooltip = ({
  children,
  setIsModalOpen,
  variant,
  size,
  className,
  verticalAlign
}) => {
  return (
    <Container
      onClick={(e) => {
        e.stopPropagation();
        setIsModalOpen(true);
      }}
      variant={variant}
      size={size}
      className={className}
      verticalAlign={verticalAlign}
    >
      <AiFillQuestionCircle variant={variant} />
      {children}
    </Container>
  );
};

IconTooltip.propTypes = {
  children: PropTypes.node,
  setIsModalOpen: PropTypes.func,
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  verticalAlign: PropTypes.string
};

const ListItems = ({ listItems }) => {
  return (
    <List>
      {listItems.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </List>
  );
};

ListItems.propTypes = {
  listItems: PropTypes.array.isRequired
};

const Tooltip = ({
  children,
  listItems,
  variant,
  size,
  infoSize,
  left,
  text,
  className,
  verticalAlign
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderInfo = () => {
    if (!(children || listItems)) return;
    return (
      <Info left={left} infoSize={infoSize}>
        {children}
        {listItems && <ListItems listItems={listItems} />}
      </Info>
    );
  };

  return (
    <>
      {window.innerWidth < SCREEN_SIZES.desktop && (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {children}
          {listItems && <ListItems listItems={listItems} />}
        </Modal>
      )}
      {variant === 'underline' ? (
        <TextTooltip setIsModalOpen={setIsModalOpen} text={text} className={className}>
          {renderInfo()}
        </TextTooltip>
      ) : (
        <IconTooltip
          setIsModalOpen={setIsModalOpen}
          variant={variant}
          size={size}
          className={className}
          verticalAlign={verticalAlign}
        >
          {renderInfo()}
        </IconTooltip>
      )}
    </>
  );
};

Tooltip.defaultProps = {
  variant: 'light',
  size: 'normal',
  infoSize: 'normal',
  left: false,
  verticalAlign: 'middle'
};

Tooltip.propTypes = {
  children: PropTypes.node,
  listItems: PropTypes.array,
  variant: PropTypes.oneOf(['light', 'dark', 'grey', 'underline']),
  size: PropTypes.oneOf(['small', 'normal', 'tiny']),
  infoSize: PropTypes.oneOf(['normal', 'wide']),
  left: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
  verticalAlign: PropTypes.string
};

export default Tooltip;
